import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextArea from '../common/textarea/TextArea';
import SelectDropDownBtn from '../common/button/SelectDropDownBtn';

const ReqFormQuestionBlock = styled.div``;

const ReqFormQuestion = ({options, questionHandler, index, handleFocus ,handleBlur}) => {
    const [brandId, setBrandId] = useState(-1);
    const [question, setQuestion] = useState("");
    const [opt, setOpt] = useState([]);

    useEffect(() => {
        if(options !== null && options !== undefined) {
            let option = [];
            Object.assign(option,options)
            setOpt(option);
        }
    }, [options])


    const handleChangeBrand = (param) => {
        //console.log("param = " + JSON.stringify(param));
        setBrandId(param.value);
        questionHandler(param.value, question, index);
    }

    const handleQuestionChange = (e) => {
        //console.log("question  = " + JSON.stringify(e.target.value));
        setQuestion(e.target.value);
        questionHandler(brandId, e.target.value, index);
        /* setQuestion(e.target.value);
        questionHandler(e.target.value); */
    }

    const onFocus = () => {
        if(handleFocus&&handleFocus!==undefined) {
            handleFocus();
        }
    }
    const onBlur = () => {
        if(handleBlur&&handleBlur!==undefined) {
            handleBlur();
        }
    }

    return (
        <ReqFormQuestionBlock>
            <div className="default-select margin_b-10" style={{width:'100%'}}>
                <SelectDropDownBtn
                    options={opt}
                    placeholder="브랜드를 선택해주세요"
                    handleFocus={onFocus} 
                    handleBlur={onBlur}
                    onChange={handleChangeBrand} />
            </div>
            <div className="input-content clearfix margin_b-20" style={{display: brandId >= 0 ? 'block' : 'none', width:'100%'}}>
                <TextArea placeholder="브랜드별 견적 문의 내용을 입력해주세요"
                    height="120px" onChange={handleQuestionChange} handleFocus={onFocus} 
                    handleBlur={onBlur}/>
                {/* // <textarea className="input-textarea" style={{ "height": "160px" }} placeholder="패키지 관련 문의 사항을 기입해주세요"></textarea> */}
            </div>
        </ReqFormQuestionBlock>
    );
};

export default ReqFormQuestion;